import React from "react";
import { useNavigate } from "react-router-dom";
import UtilsUnit from "../../../utils/UtilsUnit";
import ConstantsImages from "../../../constants/ConstantsImages";
import WidgetIcon from "../../icons/widget-icon/WidgetIcon";
import WidgetTooltipWrapper from "../widget-tooltip-wrapper/WidgetTooltipWrapper";
import ConstantsTexts from "../../../constants/ConstantsTexts";

const WidgetModelIcon = ({ userData, editMode = false }) => {
  const navigate = useNavigate();

  if (!UtilsUnit.editorUserAbove(userData)) return null;

  const backgroundColor = editMode ? "#696E83" : "#2e2e2e";
  const cursor = editMode ? "default" : "pointer";

  return (
    <WidgetTooltipWrapper content={ConstantsTexts.CODE_3}>
      <WidgetIcon
        iconProp={ConstantsImages.MODEL_IMAGE}
        backgroundColorProp={backgroundColor}
        widthIconProp="1.7rem"
        heightIconProp="1.6rem"
        cursorProp={cursor}
        handleOnClickProp={() => UtilsUnit.handleModelFrameClick(navigate, editMode)}
        customClassNameProp="widget-model-icon"
        dataHoverDisabled={editMode}
      />
    </WidgetTooltipWrapper>
  );
};

export default WidgetModelIcon;
